import classNames from "classnames";
import Button from "../../../custom/button/button";
import styles from "../styles.module.scss";
import { baseUrl } from "../../../requests";
import { useAtomValue } from "jotai";
import { otherPayment } from "../../../state";
import { formatCurrency } from "../../../utils/formatCurrency";
import usePayment from "../../../hooks/usePayment";

const PayForOther = ({ amount, email }: { amount: number; email: string }) => {
  const { makePayment, isPending } = usePayment();
  const otherPaymentDetails = useAtomValue(otherPayment);

  const handlePayment = async () => {
    const payload: ProcessPaymentPayload = {
      RouteId: otherPaymentDetails?.RouteId!,
      MembershipNo: email,
      Amount: amount || otherPaymentDetails?.Amount!,
      Description: "Other Payment",
      ReturnURL: `${baseUrl}/non-member-events/other`,
      PaymentForm: "Other",
      DataId: otherPaymentDetails?.DataId!,
    };
    makePayment(payload, (data) => {
      const responseData = JSON.parse(data?.ResponsePayLoad) as PaymentDetails;
      window.location.href = responseData?.RedirectURL;
    });
  };

  return (
    <section className={classNames("card")}>
      <h2>Pay for Training</h2>
      <div className={styles.line}></div>
      <p>
        You are one step away to complete your event registration. Proceed to
        pay <b>{formatCurrency(amount)}</b> before the event date.
      </p>
      <br />
      <Button
        isLoading={isPending}
        disabled={isPending}
        onClick={handlePayment}
        type="button"
        text="Make Payment"
      />
    </section>
  );
};

export default PayForOther;
